/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import axios from "axios";
import { EnvironmentInfo } from "./environment-info.interfaces";

const BASE_URL = "/api/v1/data-manager";

export const getEnvironmentInfo = async (): Promise<EnvironmentInfo> => {
    const response = await axios.get(`${BASE_URL}/envInfo`);

    return response.data?.envInfo || {};
};
